function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_1-2",
  "data-name": "Livello 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.39,22.48H24a1.44,1.44,0,1,1,0,2.87H12.74a1.44,1.44,0,1,1,0-2.87Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.09,14.07h2.26a1.44,1.44,0,1,1,0,2.87H21.77a1.44,1.44,0,1,1,0-2.87Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.67,16.94H10.41a1.44,1.44,0,1,1,0-2.87h4.52a1.44,1.44,0,1,1,0,2.87Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_50",
  "data-name": "Raggruppa 50"
}, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_49",
  "data-name": "Raggruppa 49"
}, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_48",
  "data-name": "Raggruppa 48"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_28",
  "data-name": "Tracciato 28",
  d: "M18.38,36.75A18.38,18.38,0,1,1,36.75,18.38h0A18.39,18.39,0,0,1,18.38,36.75Zm0-34.45A16.08,16.08,0,1,0,34.45,18.38h0A16.09,16.09,0,0,0,18.38,2.3Z"
}))))));

function SvgRelaxFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.75 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxFace);
export default __webpack_public_path__ + "static/media/relaxFace.ecc32898.svg";
export { ForwardRef as ReactComponent };